import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  showArrow?: boolean;
  variant?: 'primary' | 'secondary';
  className?: string;
}
export function PrimaryButton({
  children,
  onClick,
  href,
  size = 'lg',
  fullWidth = false,
  showArrow = true,
  variant = 'primary',
  className = ''
}: PrimaryButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-3.5 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  const variantClasses = variant === 'secondary' ? 'bg-primary transition-colors duration-200 hover:bg-accent' : 'btn-cta';
  const sharedClassName = `group inline-flex items-center justify-center gap-2 ${sizeClasses} ${fullWidth ? 'w-full' : ''} rounded-lg ${variantClasses} font-body font-semibold text-white active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 ${className}`;
  const content = <>
      {children}
      {showArrow && <ArrowRightIcon size={size === 'lg' ? 20 : 18} className="transition-transform duration-200 group-hover:translate-x-1" data-id="element-254" data-mp="btf064pqdbjr" />}
    </>;
  if (href) {
    return <a href={href} className={sharedClassName} data-id="element-255" data-mp="lruqw6kuiisq">
        {content}
      </a>;
  }
  return <button onClick={onClick} className={sharedClassName} data-id="element-256" data-mp="3u7o4odnslg63">
      {content}
    </button>;
}